import { getOverviewPanes } from "./overview_registry.js";
import { HelmLayout } from "./layouts.js";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

function OverviewPageContent() {
  const panes = getOverviewPanes();
  return (
    <div className="grid gap-4 p-4 md:grid-cols-2">
      {panes.map(pane => (
        <Card key={pane.type}>
          <CardHeader>
            <CardTitle>{pane.title}</CardTitle>
          </CardHeader>
          <CardContent>
            <pane.content />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export function OverviewPage() {
  return (
    <HelmLayout>
      <OverviewPageContent />
    </HelmLayout>
  );
}
